// Module
var code = "<div class=\"calendar-container\"></div>\n";
// Exports
module.exports = code;